import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { pxToRem } from "styled-media-query";

export const ServiceWrapper = styled.div.attrs(({ theme }) => ({}))`
  background-color: ${({ theme }) => theme.colors.white};
  margin: 0 auto;
  max-width: ${({ theme }) => theme.grid.outer};
  position: relative;
  padding: 3rem 3rem 4.625rem 3rem;
  flex-wrap: wrap;

  ${media.lessThan(breakpoints.ipad)`
  padding: 3rem 1rem 3.125rem 1rem;
  word-break: break-word;
  	`}

  ${media.lessThan(breakpoints.mobile)`

`}
`;
